import moment from "moment";

export const adaptVisitaToHistorial = (visita) => {
    const historial = [];

    // Validación/Rechazo
    if (!!visita?.idUsuarioValidadorNavigation?.nombre) {
        historial.push({
            fecha: visita?.fechaValidacion,
            usuario: visita?.usuarioValidador,
            accion: visita?.observacionRechazo ? 'Rechazo' : 'Aprobación',
            justificacion: visita?.observacionRechazo || null
        });
    }

    // Anulación
    if (!!visita?.idUsuarioAnuladorNavigation?.nombre) {
        historial.push({
            fecha: visita?.fechaAnulacion,
            usuario: visita?.usuarioAnulador,
            accion: 'Anulación',
            justificacion: visita?.observacionAnulacion || null
        });
    }

    // Modificación
    if (!!visita?.idUsuarioModificacionNavigation?.nombre) {
        historial.push({
            fecha: visita?.fechaModificacion,
            usuario: visita?.usuarioModificador,
            accion: 'Modificación',
            justificacion: null // No hay campo de observación para modificación
        });
    }

    // Ordenar por fecha (más reciente primero, ajusta si necesitas al revés)
    return historial.sort((a, b) => {
        if (!a.fecha) return 1;
        if (!b.fecha) return -1;
        return moment(a.fecha).diff(moment(b.fecha));
    });
}